
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1t44z_oag09_145",
  "popover-body": "awsui_popover-body_1t44z_oag09_178",
  "footer": "awsui_footer_1t44z_oag09_182"
};
  